import { initializeApp } from "firebase/app";
import { getAuth, signOut, signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";

const getFirebaseConfig = async () => {
  const response = await fetch(`${window.cmai.config.apiURL}firebase-config`);
  return response
    .json()
    .then((result) => {
      return result;
    })
    .catch((err) => console.log("Error loading firebase config", err.json ? err.json() : err));
};

const firebaseConfig = await getFirebaseConfig();
const app = initializeApp(firebaseConfig);
export const firebase = getAuth(app);

export const loginWithEmail = async (email, password) =>
  await signInWithEmailAndPassword(firebase, email, password).then((result) => result.user.toJSON());

export const logout = async () => {
  try {
    await signOut(firebase);
    await fetch(`${window.cmai.config.apiURL}logout`, {
      credentials: "include",
    });
  } catch (e) {
    console.log("Logout error", e);
  }
};

export const resetPassword = async (email) => await sendPasswordResetEmail(firebase, email);
